import React from "react";

import {
  AdminPanelRenderer,
} from "../panel_engine";
import {
  WorkspaceNavigationProvider,
} from "../workspace_engine";
import {
  useAdminRuntime,
} from "./AdminRuntimeContext";

export default function AdminPanelRuntime({
  fallback = null,
}) {
  const {
    panelMode,
    panelContext,
    panelKey,
    isFullscreen,
    hasRegisteredPanel,
    openPanel,
    closePanel,
    toggleFullscreen,
  } = useAdminRuntime();

  if (!hasRegisteredPanel) {
    return fallback;
  }

  return (
    <WorkspaceNavigationProvider
      openPanel={openPanel}
      panelContext={panelContext}
    >
      <AdminPanelRenderer
        panelMode={panelMode}
        panelKey={panelKey}
        isFullscreen={isFullscreen}
        onToggleFullscreen={toggleFullscreen}
        onClose={closePanel}
      />
    </WorkspaceNavigationProvider>
  );
}
